import { Injectable} from '@angular/core';
import { ModalComponent } from './../modal/modal.component';
import { MatDialog } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class ModalService {

	  private subject: BehaviorSubject<any> = new BehaviorSubject<any>({});
	  
	  constructor(private dialog: MatDialog) {}
	  
	  
	  getModal(): Observable<any> {
	    return this.subject.asObservable();
	  }

	  public 	 openModal() {
		   this.dialog.open(ModalComponent, {});
		  }
	  
	  
	  updateMpdal(v: any): void {
		  
	    this.subject.next(v);
	  }
	  
	  updateMpdalbyPath(v: any): void {
		  
	    this.subject.next(v);
	  }
}